// Created by: Imran Khan July 2026
import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { formatCurrency } from "./financialYearUtils";

Chart.register(ArcElement, Tooltip, Legend, ChartDataLabels);

export default function DashboardDonutChart({ title, data = [], centerLabel }) {
  const chartData = useMemo(() => {
    const filtered = data.filter((item) => Number(item.value) > 0);
    return {
      labels: filtered.map((item) => item.label),
      datasets: [
        {
          data: filtered.map((item) => item.value),
          backgroundColor: filtered.map((item) => item.color),
          borderWidth: 0,
        },
      ],
    };
  }, [data]);

  const total = data.reduce((sum, item) => sum + (Number(item.value) || 0), 0);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "68%",
    layout: {
      padding: 4,
    },
    plugins: {
      // Disable chart.js built-in legend — we use our own HTML legend below
      legend: { display: false },
      datalabels: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx) => `${ctx.label}: ${formatCurrency(ctx.raw)}`,
        },
      },
    },
  };

  return (
    <div className="fy-panel">
      {title && <h5 className="fy-panel-title">{title}</h5>}
      <div className="fy-donut-wrap">
        {/* Fixed-size donut container so absolute centering works */}
        <div className="fy-donut-chart">
          <Doughnut data={chartData} options={options} />
          <div className="fy-donut-center">
            <strong>{centerLabel ?? total}</strong>
            <small>Total</small>
          </div>
        </div>
        {/* Custom HTML legend */}
        <div className="fy-donut-legend">
          {data.filter((item) => Number(item.value) > 0).map((item) => (
            <div key={item.label} className="fy-legend-item">
              <span className="fy-legend-dot" style={{ backgroundColor: item.color }} />
              <span>{item.label}</span>
              <strong>{formatCurrency(item.value, item.label.includes("Revenue") ? "crore" : "full")}</strong>
              {item.percent != null && <small>{item.percent}%</small>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
